import axios from 'axios';
import xhrRoutes from './routes/xhr';

export default function () {
  const profilePictureElement = document.querySelector('.js-profile-picture');
  const route = xhrRoutes.user.updateProfileImage;

  profilePictureElement.addEventListener('change', function () {
    const form = document.querySelector('.js-profile-picture form');
    const input = document.querySelector('.js-profile-picture form input[type=file]');
    const imageElement = document.querySelector('.js-profile-picture .js-profile-picture-element');
    let formData = new FormData(form);
    route.params.user = form.dataset.id;

    formData.append('image', input.files[0]);
    for (let prop in route.params) {
      formData.append(prop, route.params[prop]);
    }

    axios.post(route.url, formData)
      .then(function (response) {
        imageElement.src = response.data.data.location;
      })
      .catch(function (error) {
        console.log(error);
      });
  });
};
